import { render, staticRenderFns } from "./TotalMentalHealthYourImpact.vue?vue&type=template&id=39bd1104"
import script from "./TotalMentalHealthYourImpact.vue?vue&type=script&lang=js"
export * from "./TotalMentalHealthYourImpact.vue?vue&type=script&lang=js"
import style0 from "./TotalMentalHealthYourImpact.vue?vue&type=style&index=0&id=39bd1104&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports